import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PopperUnstyled from '@mui/base/PopperUnstyled';
import { HTMLElementType, refType } from '@mui/utils';
import { useThemeWithoutDefault as useTheme } from '@mui/system';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/components/autocomplete/)
 * - [Menus](https://mui.com/components/menus/)
 * - [Popper](https://mui.com/components/popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/api/popper/)
 */
const Popper = /*#__PURE__*/React.forwardRef(function Popper(props, ref) {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(PopperUnstyled, _extends({
    direction: theme == null ? void 0 : theme.direction
  }, props, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Popper;